import { useEffect } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { constants } from "@qgiv/core-js";
import { useDispatch } from "react-redux";

const PreselectTeam = ({
    baseUrl,
    Team,
    hasActiveClassificationAssociatedWithTeamAndShouldBeLimited,
    classificationIdForPreselectedTeam,
    teamId,
    updateRegistration,
    updateRegistrationClassification,
    teamShouldBeSet,
}) => {
    const {
        ENUMS: {
            EntityType: { TEAM },
        },
    } = constants;

    const dispatch = useDispatch();

    useEffect(() => {
        if (teamShouldBeSet) {
            dispatch(
                updateRegistration({
                    index: 0,
                    registration: {
                        Registration_Role: [`${TEAM}`],
                        Team: teamId,
                        Team_Captain: false,
                    },
                }),
            );
        }

        if (hasActiveClassificationAssociatedWithTeamAndShouldBeLimited) {
            dispatch(
                updateRegistrationClassification({
                    Classification: [`${classificationIdForPreselectedTeam}`],
                }),
            );
        }
    }, []);
    const navigate = useNavigate();
    useEffect(() => {
        if (Team === teamId || !teamShouldBeSet) {
            navigate(`${baseUrl}/form`);
        }
    }, [Team]);
    return null;
};

PreselectTeam.propTypes = {
    baseUrl: PropTypes.string.isRequired,
    Team: PropTypes.string,
    updateRegistration: PropTypes.func.isRequired,
    teamId: PropTypes.string,
    hasActiveClassificationAssociatedWithTeamAndShouldBeLimited:
        PropTypes.bool.isRequired,
    classificationIdForPreselectedTeam: PropTypes.number,
    updateRegistration: PropTypes.func.isRequired,
    updateRegistrationClassification: PropTypes.func.isRequired,
    teamShouldBeSet: PropTypes.bool.isRequired,
};

export default PreselectTeam;
